module.exports = __webpack_public_path__ + "static/img/img_3.8149ce16.jpg";